import * as Headless from '@sail/theme-headless';
import {css, theme} from '../theme';

export const Banner = theme(Headless.Banner, [
  css({
    padding: 'medium',
    border: css.value('1px solid $borderColor.neutral'),
    borderRadius: 'small',
    lineHeight: css.value('20px'),
    fontSize: css.value('14px'),

    '& > svg': {
      height: css.value('12px'),
      width: css.value('12px'),
    },
    [Headless.BannerVariants.type.default]: {
      background: 'surface',
      '& > svg': {
        fill: 'secondary',
      },
      '& > button > svg': {
        fill: css.value('$iconColor.primary'),
      },
    },
    [Headless.BannerVariants.type.caution]: {
      background: css.value('$color.attention50'),
      borderColor: css.value('$color.attention150'),
      color: css.value('$color.attention600'),
      '& > svg': {
        fill: css.value('$iconColor.attention'),
      },
      '& > button > svg': {
        fill: css.value('$color.attention600'),
      },
    },
    [Headless.BannerVariants.type.critical]: {
      background: css.value('$color.critical50'),
      borderColor: css.value('$color.critical150'),
      color: css.value('$color.critical600'),
      '& > svg': {
        fill: css.value('$iconColor.critical'),
      },
      '& > button > svg': {
        fill: css.value('$color.critical600'),
      },
    },
  }),
]);
